export type Audience = 'companies' | 'taskers';

export interface Step {
  title: string;
  description: string;
  event: string;
}

export const steps: Record<Audience, Step[]> = {
  companies: [
    {
      title: 'Ship a brief',
      description: 'Drop a city, say what needs doing, pick your proof: photo, video, receipt, call log. Dashboard or one API call.',
      event: 'task.created',
    },
    {
      title: 'A local grabs it',
      description: 'Verified humans already in that city get pinged. Most tasks get claimed in under 15 minutes.',
      event: 'task.claimed',
    },
    {
      title: 'Proof lands, you approve',
      description: 'Check the submission against your brief. Money sits in escrow until you hit approve.',
      event: 'proof.approved',
    },
  ],
  taskers: [
    {
      title: 'Open the app',
      description: 'See paid gigs around you right now: test an app, check a store, make a call. Zero experience needed.',
      event: 'gig.claimed',
    },
    {
      title: 'Do it, snap it',
      description: 'Follow the brief, grab the screenshot or photo, upload straight from your phone. Done.',
      event: 'proof.uploaded',
    },
    {
      title: 'Cash out in 24h',
      description: '$5 to $20 a pop, sent to your bank, PayPal, or local wallet once approved.',
      event: 'payout.sent',
    },
  ],
};
